import { Input } from "design-react-kit";
import moment from "moment";
import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import Select from "../../Components/Select";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { MUNICIPI } from "../../Components/listaMunicipi";
import { TokenContext } from "../../Components/TokenContext";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import SelectComponent from "../../Components/SelectComponent";
import { useUser } from "../../Components/UserContext";
import StateLabel from "../../Components/StateLabel";
import ActionEtichettaCard from "../../Components/ActionEtichettaCard";
import { CartellaSocialeReadOnly } from "../../Components/CartellaSociale";
import UserTabs, { TABS } from "../../Components/Tabs/UserTabs";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const getTabFromQuery = (query) => {
  const tab = query.get("tab");
  return Object.values(TABS).includes(tab) ? tab : TABS.ANAGRAFICA;
};

function EditUser(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenState, toggleModalState] = useState(false);

  const [validation, setValidation] = useState(false);
  const [validationBirth, setValidationBirth] = useState(true);
  const [user, setUser] = useState();
  const [userIsees, setUserIsees] = useState();
  const [userIseesTemp, setUserIseesTemp] = useState();
  const [userSubscriptions, setUserSubscriptions] = useState();
  const [userSubscriptionsTemp, setUserSubscriptionsTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [citizenId, setCitizenId] = useState(null);
  const [ticketsTemp, setTicketsTemp] = useState(0);
  const [isOpenIsee, setIsOpenIsee] = useState(false);
  const [selectedIseeId, setSelectedIseeId] = useState(null);

  const [borderEmailColor, setBorderEmailColor] = useState("gray");
  const [emailIcon, setEmailIcon] = useState("it-error"); // default
  const [emailStatusClass, setEmailStatusClass] = useState("icon-danger"); // di default errore
  const [iseeDate, setIseeDate] = useState("");

  const [searchMode, setSearchMode] = useState("data");
  const [protocolloDSU, setProtocolloDSU] = useState("");

  let query = useQuery();

  const history = useHistory();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(() => getTabFromQuery(query));

  useEffect(() => {
    setActiveTab(getTabFromQuery(query));
  }, [query]);

  const changeTab = (tab) => {
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    history.replace({ search: params.toString() });
  };

  const { delegate, operator } = useUser();

  useEffect(() => {
    const id = query.get("citizen");

    if (!id) {
      redirectToUserList();
      return;
    }

    setCitizenId(id);
  }, [query]);

  useEffect(() => {
    if (!citizenId || !apiToken) return;

    const run = async () => {
      setLoading(false);
      try {
        await Promise.all([
          handleUpdatePosizioneDebitoria(),
          loadUser(citizenId),
        ]);
      } finally {
        setLoading(true);
      }
    };

    run();
  }, [citizenId, apiToken]);

  useEffect(() => {
    if (!apiToken || !citizenId) {
      setTicketsTemp(0);
      return;
    }

    Repo.getTicketsUser(apiToken, citizenId)
      .then((response) => {
        if (response.status === 200) {
          setTicketsTemp(response.data.length);
        }
      })
      .catch((error) => {
        console.error("Errore nel recupero ticket:", error);
      });
  }, [apiToken, citizenId]);

  const getPayments = (fiscalCode) => {
    Repo.getListPaymentOperator(apiToken, "", fiscalCode)
      .then((response) => {
        if (response.status == 200) {
          setPaymentsTemp(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const redirectToUserList = () => {
    window.location.href = props.subfolder + "/lista_utenti";
  };

  const handleUpdatePosizioneDebitoria = async () => {
    if (query.get("idTransazione") == null) return;

    const data = JSON.stringify({
      idTransazione: query.get("idTransazione"),
      EsitoWisp: query.get("EsitoWisp"),
      FaultWisp: query.get("FaultWisp"),
      IdentificativoPagamenti: query.get("IdentificativoPagamenti"),
      IUV: query.get("IUV"),
    });

    try {
      await Repo.postUpdatePosizioneDebitoria(apiToken, data);
      alert(data);
    } catch (error) {
      console.log(error);
    }
  };

  const loadUser = async (citizenId) => {
    try {
      const response = await Repo.getUserOperator(apiToken, citizenId);

      setUser(response.data);
      setUserIseesTemp(response.data.isees);
      setUserSubscriptionsTemp(response.data.subscriptions);
      getPayments(response.data.fiscalCode);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const syncUserFromANPR = async () => {
    if (!apiToken || !user?.fiscalCode || !citizenId) return;

    setLoading(false);

    try {
      await Repo.getANPRIns(apiToken, user.fiscalCode);
      await loadUser(citizenId); // 🔥 refresh dati utente
    } catch (error) {
      console.error("Errore sincronizzazione ANPR:", error);
      alert("Errore durante l'aggiornamento da ANPR");
    } finally {
      setLoading(true);
    }
  };

  const deleteIsee = async () => {
    Repo.deleteIsee(apiToken, selectedIseeId)
      .then((response) => {
        if (response.status == 204) {
          setIsOpenIsee(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleModalDelete = () => {
    setIsOpenIsee(!isOpenIsee);
  };

  const modalIsee = (iseeid) => {
    setSelectedIseeId(iseeid);
    toggleModalDelete();
  };

  const importaIseeDaInps = () => {
    if (!iseeDate) {
      alert("Seleziona una data di riferimento");
      return;
    }
    setLoading(false);
    Repo.getIseeFromInps(apiToken, citizenId, iseeDate)
      .then((response) => {
        console.log("ISEE INPS:", response.data);
        history.push(
          `/lista_utenti/dati_utente/visualizza_isee?idIsee=${response.data}`,
        );
      })
      .catch((error) => {
        console.error("Errore recupero ISEE INPS", error);
        alert("Errore nel recupero ISEE da INPS");
      })
      .finally(() => {
        setLoading(true);
      });
  };

  const importaIseeDaInpsByDsu = () => {
    if (!protocolloDSU) {
      alert("Inserisci un DSU di riferimento");
      return;
    } 
    setLoading(false);
    Repo.getIseeFromInpsDSU(apiToken, citizenId, protocolloDSU)
      .then((response) => {
        console.log("ISEE INPS:", response.data);
        history.push(
          `/lista_utenti/dati_utente/visualizza_isee?idIsee=${response.data}`,
        );
      })
      .catch((error) => {
        console.error("Errore recupero ISEE INPS", error);
        alert("Errore nel recupero ISEE da INPS");
      })
      .finally(() => {
        setLoading(true);
      });
  };


 


  const userEditValidation = () => {
    setValidation(true);
    let passedValidation = true;
    console.log("a");
    Object.entries(user).forEach(([key, value]) => {
      //isArray is used to exclude the isees array in the validation
      if (
        (value == "" || value == null) &&
        !Array.isArray(value) &&
        key !== "emailPec" &&
        key !== "email" &&
        key !== "phoneNumber" &&
        key !== "municipioId" &&
        key !== "firstName" &&
        key !== "last_name" &&
        key !== "fiscal_code" &&
        key !== "state" &&
        key !== "emailStatus" &&
        key !== "note" &&
        key !== "dataDecesso" &&
        key !== "municipio"
      ) {
        passedValidation = false;
        console.log(
          " if passedValidation:" + passedValidation + " key: " + key,
        );
      }
      console.log(
        " dopo if passedValidation:" + passedValidation + " key: " + key,
      );
      if (key == "birthDate") {
        if (value == "" || value == null) {
          setValidationBirth(false);
          passedValidation = false;
        } else if (user.birthDate.isValid && !user.birthDate.isValid()) {
          setValidationBirth(false);
          passedValidation = false;
        }
      }
    });
    console.log(" 116 passedValidation:");
    if (passedValidation) {
      user.birthdate = moment(user.birthDate, "DD/MM/YYYY")
        .format("YYYY-MM-DD")
        .toString();

      setUser({ ...user });

      toggleModal(!isOpen);
    }
  };

  const editUserAPI = () => {
    setLoading(false);
    Repo.postUpdateUser(apiToken, JSON.stringify(user))
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          toggleModal(false);
          setIsDisabled(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const UpdUserAPI = (updUser) => {
    setLoading(false);
    Repo.postUpdateUser(apiToken, JSON.stringify(updUser))
      .then((response) => {
        if (response.status === 200) {
          setLoading(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const uploadIsee = (citizenId) => {
    window.location.href =
      props.subfolder +
      "/lista_utenti/dati_utente/caricamento_ISEE_operatore?userId=" +
      citizenId;
  };

  useEffect(() => {
    if (user?.emailStatus) {
      const { color, icon, className } =
        statusMap[user.emailStatus] || statusMap.invalid;
      setBorderEmailColor(color);
      setEmailIcon(icon);
      setEmailStatusClass(className);
    }
  }, [user?.emailStatus]);

  const statusMap = {
    valid: {
      color: "green",
      icon: "it-check-circle",
      className: "icon-success",
    },
    unknown: {
      color: "orange",
      icon: "it-help-circle",
      className: "icon-warning",
    },
    invalid: {
      color: "red",
      icon: "it-close-circle",
      className: "icon-danger",
    },
  };

  const validateEmail = () => {
    Repo.GetEmailVerfy(apiToken, user.email)
      .then((response) => {
        if (response.status === 200) {
          const status = response.data?.status;

          // Mappa le icone e colori
          const statusMap = {
            valid: {
              color: "green",
              icon: "it-check-circle",
              className: "icon-success",
            },
            unknown: {
              color: "orange",
              icon: "it-help-circle",
              className: "icon-warning",
            },
            invalid: {
              color: "red",
              icon: "it-close-circle",
              className: "icon-danger",
            },
          };

          const mapped = statusMap[status] || statusMap.invalid;

          // Aggiorna lo stato visuale
          setBorderEmailColor(mapped.color);
          setEmailIcon(mapped.icon);
          setEmailStatusClass(mapped.className);

          const updatedUser = { ...user, emailStatus: status || "invalid" };
          setUser(updatedUser);
          UpdUserAPI(updatedUser);
        } else {
          fallbackErrorHandling();
        }
      })
      .catch((error) => {
        fallbackErrorHandling();
        console.log("Errore validazione email:", error);
      });
  };

  const fallbackErrorHandling = () => {
    setBorderEmailColor("red");
    setEmailIcon("it-close-circle");
    setEmailStatusClass("icon-danger");

    setUser((prev) => ({
      ...prev,
      emailStatus: "invalid",
    }));
  };

  const userState = (userId) => {
    Repo.postUpdateUserStatus(apiToken, userId)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openTicket = (userId) => {
    window.location.href =
      props.subfolder + "/lista_utenti/dati_utente/ticket?userId=" + userId;
  };

  const CambiaStatoUtente = () => {
    userState(user.id);
  };

  const userStateChipMap = {
    LOADED: {
      label: "Caricato",
      className: "chip-primary",
    },
    UPLOADED: {
      label: "Caricato",
      className: "chip-primary",
    },
    VALIDATED: {
      label: "Validato",
      className: "chip-success",
    },
    REFUSED: {
      label: "Rifiutato",
      className: "chip-danger",
    },
    SUSPEND: {
      label: "Sospeso",
      className: "chip-warning",
    },
  };

  const chip = userStateChipMap[user?.state] || {
    label: user?.state,
    className: "chip-secondary",
  };

  const copyToClipboard = async (value) => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      alert("Data copiata negli appunti");
    } catch (err) {
      console.error("Errore copia:", err);
    }
  };

  return (
    <>
      <h1>
        {user && user.firstName
          ? " " + user.lastName + " " + user.firstName
          : ""}
      </h1>
      <div className="row mb-2">
        <div className="col-lg-4 text-left">
          <div className={`chip chip-simple chip-lg ${chip.className}`}>
            <span className="chip-label">{chip.label}</span>
          </div>
        </div>

        <div className="col-lg-8 text-right">
          <button
            className="btn btn-outline-primary btn-xs ml-2"
            type="button"
            title="Aggiorna da ANPR"
            onClick={syncUserFromANPR}
            disabled={delegate || !loading}
          >
            ANPR
            <svg className="icon align-middle icon-primary">
              <use href={`${iconSprite}#it-download`} />
            </svg>
          </button>

          <button
            className="btn btn-outline-primary ml-2 d-inline-flex align-items-center btn-xs"
            type="button"
            title="Attiva blocca utente"
            onClick={() => toggleModalState(true)}
          >
            {user && user.state !== "SUSPEND" ? (
              <>
                SOSPENDI
                <svg className="icon align-middle icon-primary ml-1">
                  <use href={`${iconSprite}#it-locked`} />
                </svg>
              </>
            ) : (
              <>
                ABILITA
                <svg className="icon align-middle icon-primary ml-1">
                  <use href={`${iconSprite}#it-unlocked`} />
                </svg>
              </>
            )}
          </button>

          <button
            className="btn btn-outline-primary ml-2 btn-xs"
            type="button"
            title="apri/visualizza Ticket"
            onClick={() => openTicket(query.get("citizen"))}
            disabled={delegate}
          >
            {ticketsTemp > 0 && (
              <span className="badge bg-danger text-white">{ticketsTemp}</span>
            )}{" "}
            Ticket
            <svg className="icon align-middle icon-primary">
              <use href={`${iconSprite}#it-comment`} />
            </svg>
          </button>

          <button
            type="button"
            className="btn btn-outline-primary ml-2 btn-xs"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => validateEmail()}
            title="Valida Email"
            disabled={delegate}
          >
            Valida Email
            <svg className="icon align-middle icon-primary">
              <use href={`${iconSprite}#it-check`} />
            </svg>
          </button>
        </div>
      </div>

      <UserTabs activeTab={activeTab} onChange={changeTab} />

      {activeTab === TABS.ANAGRAFICA && (
        <>
          {/*Inizio modifica dati cittadino*/}

          <div className="form-group card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body mt-4">
                <div className="row my-2">
                  <div className="col-lg-3">
                    <Input
                      id="firstName"
                      disabled={isDisabled}
                      label="Nome*"
                      type="text"
                      name="firstName"
                      value={user && user.firstName ? user.firstName : ""}
                      onChange={(e) =>
                        setUser({ ...user, firstName: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-lg-2">
                    <Input
                      id="last_name"
                      disabled={isDisabled}
                      label="Cognome*"
                      type="text"
                      name="last_name"
                      value={user && user.lastName ? user.lastName : ""}
                      onChange={(e) =>
                        setUser({ ...user, lastName: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="fiscal_code"
                      disabled={isDisabled}
                      label="Codice Fiscale*"
                      type="text"
                      name="fiscal_code"
                      value={user && user.fiscalCode ? user.fiscalCode : ""}
                      onChange={(e) =>
                        setUser({ ...user, fiscalCode: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-lg-2">
                    <Input
                      id="birthdate"
                      readOnly={isDisabled}
                      label="Data di Nascita*"
                      type="date"
                      name="birthdate"
                      onClick={() => copyToClipboard(user?.birthDate)}
                      title="Clicca per copiare la data"
                      className="cursor-copy"
                      placeholder="gg/mm/aaaa"
                      value={
                        user && user.birthDate != null
                          ? moment(user.birthDate, "DD/MM/YYYY")
                              .format("YYYY-MM-DD")
                              .toString()
                          : ""
                      }
                      onChange={(e) =>
                        setUser({
                          ...user,
                          birthDate: moment(e.target.value),
                        })
                      }
                      {...(validation &&
                        !validationBirth && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>

                  <div className="col-lg-2">
                    <Input
                      id="dataDecesso"
                      disabled={isDisabled}
                      label="Data Decesso"
                      type="date"
                      name="dataDecesso"
                      style={{ backgroundColor: "tan" }}
                      placeholder="gg/mm/aaaa"
                      value={
                        user && user.dataDecesso != null
                          ? moment(user.dataDecesso, "DD/MM/YYYY")
                              .format("YYYY-MM-DD")
                              .toString()
                          : ""
                      }
                      onChange={(e) =>
                        setUser({
                          ...user,
                          dataDecesso: moment(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-5">
                    <svg
                      className={`icon icon-email ${emailStatusClass}`}
                      style={{ marginTop: "30px" }}
                    >
                      <use href={`${iconSprite}#${emailIcon}`} />
                    </svg>

                    <Input
                      id="email"
                      disabled={isDisabled}
                      label="Email"
                      type="text"
                      name="email"
                      style={{ borderColor: borderEmailColor }}
                      value={user && user.email ? user.email : ""}
                      onChange={(e) =>
                        setUser({ ...user, email: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-lg-4">
                    <Input
                      id="emailPec"
                      disabled={isDisabled}
                      label="Pec"
                      type="text"
                      name="emailPec"
                      value={user && user.emailPec ? user.emailPec : ""}
                      onChange={(e) =>
                        setUser({ ...user, emailPec: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="phone_number"
                      disabled={isDisabled}
                      label="Telefono"
                      type="text"
                      name="phone_number"
                      value={user && user.phoneNumber ? user.phoneNumber : ""}
                      onChange={(e) =>
                        setUser({ ...user, phoneNumber: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-6">
                    <Input
                      id="address"
                      disabled={isDisabled}
                      label="Indirizzo*"
                      type="text"
                      name="address"
                      value={user && user.address ? user.address : ""}
                      onChange={(e) =>
                        setUser({ ...user, address: e.target.value })
                      }
                      {...(validation &&
                        !user.address && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="number"
                      disabled={isDisabled}
                      label="N. Civico*"
                      type="text"
                      name="number"
                      value={
                        user && user.addressNumber ? user.addressNumber : ""
                      }
                      onChange={(e) =>
                        setUser({ ...user, addressNumber: e.target.value })
                      }
                      {...(validation &&
                        !user.addressNumber && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="cap"
                      disabled={isDisabled}
                      label="CAP*"
                      type="text"
                      name="cap"
                      value={user && user.cap ? user.cap : ""}
                      onChange={(e) =>
                        setUser({ ...user, cap: e.target.value })
                      }
                      {...(validation &&
                        !user.cap && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-4">
                    <Input
                      id="city"
                      disabled={isDisabled}
                      label="Città*"
                      type="text"
                      name="city"
                      value={user && user.city ? user.city : ""}
                      onChange={(e) =>
                        setUser({ ...user, city: e.target.value })
                      }
                      {...(validation &&
                        !user.city && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-4">
                    <div className="bootstrap-select-wrapper col-12  mt-3 mt-md-1">
                      <label
                        htmlFor="selectExampleClassic"
                        className="active d-none d-md-block"
                      >
                        Provincia*
                      </label>
                      <Select
                        aria-label="Scegli una provincia*"
                        clearText="Annulla"
                        isDisabled={isDisabled}
                        defaultMenuIsOpen={false}
                        icon={false}
                        id="selectExampleClassic"
                        onChange={(e) => {
                          setUser({ ...user, country: e.value });
                        }}
                        options={PROVINCE}
                        isSearchable
                        placeholder={
                          user && user.country
                            ? PROVINCE.find(
                                (option) =>
                                  option.value == user.country.toString(),
                              )?.label || "Scegli una provincia"
                            : "Scegli un municipio"
                        }
                      />
                    </div>
                    {validation && !user.country ? (
                      <small
                        id="errorSelect"
                        className="form-text  text-danger"
                      >
                        Il campo non può essere vuoto!
                      </small>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="col-lg-4  mt-3 mt-md-1">
                    <div className="bootstrap-select-wrapper col-12">
                      <label htmlFor="nation" className="d-none d-md-block">
                        Nazione
                      </label>
                      <SelectComponent
                        options={NAZIONI}
                        id="nation"
                        value={user && user.nation ? user.nation : null}
                        onChange={(e) => setUser({ ...user, nation: e.value })}
                        placeholder="Seleziona*"
                        isDisabled={isDisabled}
                        isRequired={true}
                        validation={true}
                        columnClass="col-12" // Classe CSS delle colonne di Bootstrap
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-lg-12 mt-3 mt-md-1">
                    <div className="bootstrap-select-wrapper col-12">
                      <label
                        htmlFor="selectExampleClassic"
                        className="d-none d-md-block"
                      >
                        Municipio
                      </label>
                      <Select
                        options={MUNICIPI}
                        value={
                          user && user.municipioId ? user.municipioId : null
                        }
                        onChange={(e) =>
                          setUser({ ...user, municipioId: e.value })
                        }
                        placeholder={
                          user && user.municipioId
                            ? MUNICIPI.find(
                                (option) =>
                                  option.value == user.municipioId.toString(),
                              )?.label || "Scegli un municipio"
                            : "Scegli un municipio"
                        }
                        isDisabled={isDisabled}
                        isRequired={false}
                        validation={false}
                        columnClass="col-12"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-2 align-items-center">
                  <div className="col-lg-8">
                    
                    {user?.dataDecorrenza ? (
                      <span>
                        <strong>
                          Data di decorrenza del cambio di residenza:
                        </strong>{" "}
                        {user.dataDecorrenza} (fonte ANPR)
                      </span>
                    ) : (
                      <span className="text-muted">ANPR non verificato</span>
                    )}
                  </div>

                  <div className="col-lg-4 text-right">
                    {isDisabled ? (
                      <button
                        type="button"
                        className="btn btn-outline-success btn-xs"
                        onClick={() => setIsDisabled(!isDisabled)}
                        title="Modifica"
                        disabled={delegate}
                      >
                        Modifica
                        <svg className="icon align-middle icon-success">
                          <use href={`${iconSprite}#it-pencil`} />
                        </svg>
                      </button>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-xs"
                          onClick={() => setIsDisabled(!isDisabled)}
                          title="Indietro"
                        >
                          Indietro
                          <svg className="icon align-middle icon-primary">
                            <use href={`${iconSprite}#it-check`} />
                          </svg>
                        </button>

                        <button
                          type="button"
                          className="btn btn-outline-danger ml-2 btn-xs"
                          onClick={() => userEditValidation()}
                          title="Conferma"
                          disabled={delegate}
                        >
                          Conferma
                          <svg className="icon align-middle icon-danger">
                            <use href={`${iconSprite}#it-check`} />
                          </svg>
                        </button>
                      </>
                    )}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-12 mt-3 mt-md-1">
                    <div className="form-group">
                      <label
                        htmlFor="note"
                        className="active d-none d-md-block"
                      >
                        Note
                      </label>
                      <textarea
                        id="note"
                        name="note"
                        className="form-control"
                        rows="4"
                        style={{ backgroundColor: "beige" }}
                        value={user?.note || ""}
                        onChange={(e) =>
                          setUser({ ...user, note: e.target.value })
                        }
                        onBlur={() => editUserAPI({ ...user })}
                        placeholder="Inserisci eventuali note"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*Fine modifica dati cittadino*/}
        </>
      )}

      {activeTab === TABS.ISEE && (
        <>
          {/*importa inps*/}
          <div className="col-lg-12 mt-3">
            <div className="form-group card-wrapper card-space">
              <div className="card card-bg no-after card-big roundedCustom">
                <div className="card-body">
                  <h5>Importa ISEE da INPS</h5>

                  {/* 🔘 Selettore modalità */}
<div className="mb-3">
  <div className="form-check form-check-inline">
    <input
      className="form-check-input"
      type="radio"
      id="radioData"
      value="data"
      checked={searchMode === "data"}
      onChange={() => setSearchMode("data")}
      disabled={delegate}
    />
    <label className="form-check-label" htmlFor="radioData">
      Per data
    </label>
  </div>

  <div className="form-check form-check-inline">
    <input
      className="form-check-input"
      type="radio"
      id="radioDsu"
      value="dsu"
      checked={searchMode === "dsu"}
      onChange={() => setSearchMode("dsu")}
      disabled={delegate}
    />
    <label className="form-check-label" htmlFor="radioDsu">
      Per protocollo DSU
    </label>
  </div>
</div>

                  {/* 🔄 Testo dinamico */}
                  <p className="text-muted">
                    {searchMode === "data"
                      ? "Seleziona la data di riferimento: verrà recuperato l’ISEE valido in quella data."
                      : "Inserisci il protocollo DSU per recuperare uno specifico ISEE."}
                  </p>

                  {/* 🔄 Input dinamico */}
                  <div className="form-group">
                    {searchMode === "data" ? (
                      <Input
                        id="iseeReferenceDate"
                        type="date"
                        value={iseeDate}
                        onChange={(e) => setIseeDate(e.target.value)}
                        disabled={delegate}
                      />
                    ) : (
<Input
  id="protocolloDSU"
  type="text"
  placeholder="INPS-ISEE-2026-XXXXXXXX"
  value={protocolloDSU ?? ""}
  onChange={(e) => setProtocolloDSU(e.target.value)}
  disabled={delegate}
/>
                    )}
                  </div>

                  {/* 🔘 Bottone */}
                  <div className="text-right mt-3">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() =>
                        searchMode === "data"
                          ? importaIseeDaInps(iseeDate)
                          : importaIseeDaInpsByDsu(protocolloDSU)
                      }
                      disabled={
                        delegate ||
                        (searchMode === "data" && !iseeDate) ||
                        (searchMode === "dsu" && !protocolloDSU)
                      }
                    >
                      Importa
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* inizio isee*/}
          <div className="col-lg-12 mt-3">
            <div className="form-group card-wrapper card-space">
              <div className="card card-bg no-after card-big roundedCustom">
                <ActionEtichettaCard
                  label="Aggiungi"
                  iconId="it-plus"
                  onClick={() => uploadIsee(query.get("citizen"))}
                  disabled={delegate}
                />
                <div className="card-body">
                  <div className="row my-2">
                    <div className="col-lg-9">
                      <h5>
                        ISEE{" "}
                        <i>
                          {user && user.firstName
                            ? " " + user.lastName + " " + user.firstName
                            : ""}
                        </i>
                      </h5>
                    </div>
                  </div>
                  {userIseesTemp && userIseesTemp.length > 0 ? (
                    <div className="row">
                      <div className="table-responsive">
                        <div className="div-table">
                          <div className="div-table-head d-flex font-weight-bold border-bottom pb-2">
                            <div className="col-2">ISEE</div>
                            <div className="col-3 d-none d-lg-block text-left">
                              Validità
                            </div>
                            <div className="col-2">Anno</div>
                            <div className="col-4 d-none d-lg-block">
                              Protocollo
                            </div>
                            <div className="col-1 text-right">Azioni</div>
                          </div>

                          {userIsees &&
                            userIsees.length > 0 &&
                            userIsees.map((y, index) => (
                              <div
                                className="div-table-row d-flex align-items-center py-2 border-bottom"
                                key={index}
                              >
                                <div className="col-2">
                                  {y.value &&
                                    parseFloat(y.value).toLocaleString(
                                      "it-IT",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    )}
                                  &nbsp;€
                                </div>
                                <div className="col-3 d-none d-lg-block">
                                  ({y.date} -{" "}
                                  <strong>
                                    {y?.scadenza ? y.scadenza : "NaN"}
                                  </strong>
                                  )
                                </div>
                                <div className="col-2">
                                  {y.year} <StateLabel state={y.state} />
                                </div>
                                <div className="col-4 flex-2 d-none d-lg-block fw-light">
                                  {y?.protocollo}
                                </div>
                                <div className="col-1 text-right">
                                  {y.state === "LOADED" ? (
                                    <Link
                                      to={`/lista_utenti/dati_utente/verifica_isee?idIsee=${y.id}`}
                                      className="btn btn-outline-primary p-2"
                                      title="Dettaglio"
                                    >
                                      Dettaglio
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/lista_utenti/dati_utente/visualizza_isee?idIsee=${y.id}`}
                                      className="btn btn-outline-primary p-2"
                                      title="Visualizza"
                                    >
                                      <svg className="icon align-middle icon-primary">
                                        <use href={`${iconSprite}#it-search`} />
                                      </svg>
                                    </Link>
                                  )}

                                  {y.state === "REFUSED" && (
                                    <button
                                      className="btn btn-outline-danger p-2 ml-2"
                                      title="Elimina"
                                      onClick={() => modalIsee(y.id)}
                                    >
                                      <svg className="icon align-middle icon-danger">
                                        <use href={`${iconSprite}#it-delete`} />
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>

                      {user.isees && (
                        <Pagination
                          items={userIseesTemp}
                          setCurrentItems={setUserIsees}
                          itemsPerPage={5}
                        ></Pagination>
                      )}
                    </div>
                  ) : (
                    <>Non sono presenti ISEE per questo utente</>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* fine isee*/}
        </>
      )}

      {activeTab === TABS.CARTELLA && user?.cartellaSociale && (
        <CartellaSocialeReadOnly cartellaSociale={user.cartellaSociale} />
      )}

      {activeTab === TABS.ISCRIZIONI && (
        <>
          {/* inizio iscrizioni utente*/}
          <div className="col-lg-12 mt-3">
            <div className="card-wrapper card-space">
              <div className="card card-bg no-after card-big roundedCustom">
                <div className="card-body">
                  <div className="row my-2">
                    <div className="col-lg-9">
                      <h5>
                        <b>Iscrizioni</b>{" "}
                        <i>
                          {user && user.firstName
                            ? " " + user.lastName + " " + user.firstName
                            : ""}
                        </i>
                      </h5>
                    </div>
                    {userSubscriptionsTemp &&
                    userSubscriptionsTemp.length > 0 ? (
                      <>
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col">Titolo bando</th>
                              <th scope="col">Servizio</th>
                              <th scope="col">Stato Utente</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {userSubscriptions &&
                              userSubscriptions.length > 0 &&
                              userSubscriptions.map((x, index) => (
                                <tr key={index}>
                                  <td scope="row">{x.announcement.name}</td>

                                  <td>{x.announcement.service.name}</td>
                                  <td>
                                    {x.state === "VALIDATED" ? (
                                      <div className="col-12 mt-2">
                                        <svg className="icon icon-success mr-2 mb-1">
                                          <use
                                            xlinkHref={`${iconSprite}#it-check-circle`}
                                          ></use>
                                        </svg>
                                        <b className="text-success">
                                          {"Richiesta accettata".toUpperCase()}
                                        </b>
                                      </div>
                                    ) : x.state === "REFUSED" ? (
                                      <div className="col-12 mt-2">
                                        <svg className="icon icon-danger mr-2 mb-1">
                                          <use
                                            xlinkHref={`${iconSprite}#it-close-circle`}
                                          ></use>
                                        </svg>
                                        <b className="text-danger">
                                          {"Richiesta rifiutata".toUpperCase()}
                                        </b>
                                      </div>
                                    ) : x.state === "SUSPENDED" ? (
                                      <div className="col-12 mt-2">
                                        <svg className="icon icon-dark mr-2 mb-1">
                                          <use
                                            xlinkHref={`${iconSprite}#it-ban`}
                                          ></use>
                                        </svg>
                                        <b className="text-dark">
                                          {"Iscrizione sospesa".toUpperCase()}
                                        </b>
                                      </div>
                                    ) : x.state === "ADDED" ? (
                                      <div className="col-12 mt-2">
                                        <svg className="icon icon-warning mr-2 mb-1">
                                          <use
                                            xlinkHref={`${iconSprite}#it-warning-circle`}
                                          ></use>
                                        </svg>
                                        <b className="text-warning">
                                          {"Richiesta inserita"}
                                        </b>
                                      </div>
                                    ) : (
                                      <div className="col-12 mt-2">
                                        <strong className="text text-dark">
                                          NON SEI ISCRITTO
                                        </strong>
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-right">
                                    <Link
                                      to={
                                        "/lista_bandi/dettaglio_sessione?id=" +
                                        x.announcement.id
                                      }
                                      className="btn btn-outline-primary p-2"
                                      title="Modifica"
                                    >
                                      Dettaglio
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {userSubscriptionsTemp && (
                          <Pagination
                            items={userSubscriptionsTemp}
                            setCurrentItems={setUserSubscriptions}
                            itemsPerPage={3}
                          ></Pagination>
                        )}
                      </>
                    ) : (
                      <div className="mt-2 p-1">
                        L'utente non è iscritto a nessun bando
                      </div>
                    )}

                    {/* {userSubscriptionsTemp && (
                <Sessions
                  sessionsTemp={userSubscriptionsTemp}
                  sessionsList={userSubscriptions}
                  SetSessionsList={setUserSubscriptions}
                ></Sessions>
              )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {activeTab === TABS.PAGAMENTI && (
        <ListPaymemtsUsers
          payments={payments}
          paymentsTemp={paymentsTemp}
          setPayments={setPayments}
          fiscalCode={true}
          userId={citizenId}
        />
      )}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={
          user && "Modifica utente: " + user.firstName + " " + user.lastName
        }
        body={
          user &&
          "Confermi di voler modificare i dati di " +
            user.firstName +
            " " +
            user.lastName +
            "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => editUserAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalState}
        isOpen={isOpenState}
        header="Cambia Stato"
        body={
          user &&
          `Confermi di voler modificare lo stato in ${
            user.state === "VALIDATED" ? "SOSPESO" : "ATTIVO"
          } di ${user.firstName} ${user.lastName}?`
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => CambiaStatoUtente()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalDelete}
        isOpen={isOpenIsee}
        header="Eliminazione ISEE"
        body="Sei sicuro di voler eliminare questo ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={deleteIsee}
      />

      {!loading && <Loader></Loader>}
    </>
  );
}

export default EditUser;
